import { Product, ProductShortName } from '@app/enums/_index';

import { CheckItem } from '@app/models/_index';
import { Factory } from './_factory';

/**
 * Create Product CheckItem Factory used by application
 * Creates instances of Product Check Items.
 */
export class ProductCheckItemFactory implements Factory<CheckItem> {
  products: CheckItem[] = [];

  /**
   * Call and build static Product Check Items array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static Product Check Items array
   */
  build(): void {
    this.products.push(
      new CheckItem(
        ProductShortName.GENESYS_CLOUD,
        Product.GENESYS_CLOUD,
        false,
        Product.GENESYS_CLOUD_DISPLAY_NAME,
        ''
      )
    );
    this.products.push(
      new CheckItem(
        ProductShortName.GENESYS_ENGAGE,
        Product.GENESYS_ENGAGE,
        false,
        Product.GENESYS_ENGAGE_DISPLAY_NAME,
        ''
      )
    );
  }

  /**
   * Return immutable or copy of Product Check Items collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): CheckItem[] {
    if (this.products && this.products.length === 0) {
      this.build();
    }
    return this.products.slice();
  }
}
